import { render, staticRenderFns } from "./DashBoardIndicadoresSemestral.vue?vue&type=template&id=d2b6cacc&"
import script from "./DashBoardIndicadoresSemestral.vue?vue&type=script&lang=js&"
export * from "./DashBoardIndicadoresSemestral.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardIndicadoresSemestral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports